import React, { useMemo, useState } from 'react';
import DateSelection from '../../../Case/Components/Create/DateSelection/DateSelection';
import { CustomTimePickerTime } from '../../../BaseModule/Components/TimePickerCustom/TimePickerCustom';
import moment from 'moment-timezone';

interface Props {
	workplaceId: string;
	workplaceMemberId: string;
	workplaceCaseTypeId: string;
	minDate?: string;
	maxDate?: string;
	preselectedDateTime?: string;
}

const WizardTermSelectWrapper: React.FC<Props> = props => {
	const [selectedTerm, setSelected] = useState<
		CustomTimePickerTime | undefined
	>();

	const { start, end }: { start: string; end: string } = useMemo(() => {
		if (!selectedTerm?.date || !selectedTerm?.from || !selectedTerm?.to) {
			return {
				start: '',
				end: '',
			};
		}
		return {
			start: moment(
				`${selectedTerm.date} ${selectedTerm.from}`,
				'YYYY-MM-DD HH:mm',
			).format(),
			end: moment(
				`${selectedTerm.date} ${selectedTerm.to}`,
				'YYYY-MM-DD HH:mm',
			).format(),
		};
	}, [selectedTerm]);

	const handleSelect = (data: CustomTimePickerTime) => {
		setSelected(data);
	};
	return (
		<>
			<DateSelection {...props} onSelect={handleSelect} />
			<input
				name='date'
				type='text'
				value={selectedTerm?.date}
				style={{ display: 'none' }}
			/>
			<input
				name='start'
				type='text'
				value={start}
				style={{ display: 'none' }}
			/>
			<input name='end' type='text' value={end} style={{ display: 'none' }} />
		</>
	);
};

export default WizardTermSelectWrapper;
